import { Icon } from './Icon.js';

export function EmptyState(props: { title: string; hint?: string | undefined }) {
  return (
    <div className="flex flex-col items-center rounded-[var(--admin-radius,0.625rem)] border border-dashed border-[color:var(--admin-border,#d8dee6)] bg-[color:var(--admin-surface,#fff)] px-6 py-12 text-center dark:border-slate-600 dark:bg-slate-900">
      <span className="grid size-10 place-items-center rounded-[var(--admin-radius-sm)] border border-[color:var(--admin-border)] text-slate-400 dark:border-slate-700 dark:text-slate-500">
        <Icon name="inbox" className="size-4" />
      </span>
      <p className="admin-display mt-4 text-sm font-semibold text-slate-800 dark:text-slate-200">
        {props.title}
      </p>
      {props.hint ? (
        <p className="mt-1.5 max-w-sm text-sm leading-relaxed text-slate-500 dark:text-slate-400">
          {props.hint}
        </p>
      ) : null}
    </div>
  );
}
